import * as filtersHelper from "@/helpers/filters.helper"
import type { TFunction } from "@/hooks/useTranslation"
import { Filters } from "@/organisms/SmartSearch/types/options.types"
import {
  getRuntimeFilter,
  getSeverityFilter,
  InventoryFilters
} from "@/pages/DiscoveryPage/utils/filters.utils"

export const getFilters = (
  t: TFunction,
  environmentOptions?: { label: string; value: string }[]
): Filters => {
  const keyValues = "filters.helpers.multipleValues"

  return [
    InventoryFilters.application(t),
    InventoryFilters.repositoryName(t),
    InventoryFilters.repositoryName(t, { strictEquality: true }),
    InventoryFilters.imageName(t),
    filtersHelper.getBaseImageNameFilter(t),
    filtersHelper.getBaseImageDigestFilter(t),
    InventoryFilters.environment(t, environmentOptions),
    InventoryFilters.namespace(t),
    getRuntimeFilter(),
    getSeverityFilter(),
    filtersHelper.getVulnerabilityIdFilter(t),
    filtersHelper.getCveIdFilter(t),
    filtersHelper.getHighProfileFilter(t),
    {
      key: "tag",
      label: t("filters.tag"),
      type: "input",
      helper: [
        {
          label: t(keyValues, { label: t("filters.tag") }),
          description: t("inventory.generalFilters.multipleSubstring", {
            name: "tags"
          })
        }
      ]
    },
    filtersHelper.getOsFilter(t),
    {
      key: "publicImage",
      label: t("filters.publicImage"),
      type: "single",
      options: [
        { label: "Yes", value: "YES" },
        { label: "No", value: "NO" }
      ]
    },
    {
      key: "isThirdParty",
      label: t("filters.isThirdParty"),
      order: 6,
      type: "single",
      options: [
        { label: "Yes", value: "YES" },
        { label: "No", value: "NO" }
      ]
    },
    filtersHelper.getPackageCategoryAI(t),
    filtersHelper.getIsPackageAiRelated(t)
  ]
}
